import Layout from '@/apps/layout/components'
import LiveLikeAHost from '@/apps/LiveLikeAHost'
import React from 'react'

const LiveLikeAHostPage = (): React.ReactElement => {
  return (
    <Layout>
      <LiveLikeAHost />
    </Layout>
  )
}

export default LiveLikeAHostPage
